import type { StatusFromUserType } from '~/components/Projects/model';
import type {
  InteractionType,
} from '~/model/InteractionType';
import { VpIcon } from '@vtmn-play/react/headless';
import classNames from 'classnames';
import { useTranslations } from 'next-intl';
import { checkIsSelection, checkIsSurvey, checkIsThread } from '~/components/Interaction/utils';
import {
  getColorStatusFromContributionStatus,
  getStatusFromUserContributionStatusCount,
  getStatusIconFromContributionStatus,
  getStatusTranslateKeyFromContributionStatus,
} from '~/components/utils';

export const InteractionUserStatus = ({
  interaction,
}: {
  interaction: InteractionType;
}) => {
  const t = useTranslations();
  const isSelection = checkIsSelection(interaction);
  const isSurvey = checkIsSurvey(interaction);
  const isThread = checkIsThread(interaction);
  const isForChildren = interaction?.for_children;
  const contributions = interaction.current_user_contribution?.count_per_status;
  const statuses = getStatusFromUserContributionStatusCount(contributions);

  const status = (s: StatusFromUserType) => {
    return (
      <span
        data-testid="contributions-status"
        key={s.key}
        className="interaction-user-status"
      >
        <div
          className={classNames(
            'interaction-user-status__contribution',
            getColorStatusFromContributionStatus(s.key),
          )}
        >
          <VpIcon name={getStatusIconFromContributionStatus(s.key)} size={20} />
          {t(getStatusTranslateKeyFromContributionStatus(s.key))}
          {isForChildren && s.value > 1 && (
            <span className="interaction-user-status__count">{s.value}</span>
          )}
        </div>
      </span>
    );
  };

  const selectionStatus = isSelection && !!statuses.length && (
    <>{statuses?.map(s => status(s))}</>
  );

  const participationStatus = (isSurvey || isThread)
    && contributions?.submitted > 0 && (
    <div className="interaction-user-status__contribution positive">
      <VpIcon name="check-circle" size={20} />
      {t('INTERACTION.CONTRIBUTION_STATUS.PARTICIPATED')}
    </div>
  );

  return selectionStatus || participationStatus || null;
};
